import { format, parse } from "date-fns";

/**
 * Takes a date and converts it to a string. Allow for strings to cater for dates coming back from the API.
 * @param {Date | string} val The date to format
 * @param {string?} stringFormat The format of the result string (default is dd/MM/yyyy)
 * @returns {string} The formatted string in form of the specified locale
 */
export function formatDate(
  val: Date | string | null,
  stringFormat: string = "dd/MM/yyyy"
): string | null {
  if (val) {
    return format(val, stringFormat, { awareOfUnicodeTokens: true });
  }

  return val;
}

/**
 * Takes a string and converts it to a date
 * @param {string} val The date string.
 * @param {string?} formatString The format of the date string (default is yyyy-MM-dd).
 * @returns {Date} The date from the string passed in
 */
export function parseDate(
  val: string,
  formatString: string = "yyyy-MM-dd"
): Date | null {
  if (val && typeof val === "string" && val.length === formatString.length) {
    return parse(val, formatString, new Date());
  }

  return null;
}

// ISO8601 in local time zone
export function localISOString(date: Date) {
  if (!date) {
    return null;
  }
  const tzo = -date.getTimezoneOffset();
  const dif = tzo >= 0 ? "+" : "-";
  const pad = (num: number) => {
    const norm = Math.floor(Math.abs(num));
    return (norm < 10 ? "0" : "") + norm;
  };
  return date.getFullYear() +
    "-" + pad(date.getMonth() + 1) +
    "-" + pad(date.getDate()) +
    "T" + pad(date.getHours()) +
    ":" + pad(date.getMinutes()) +
    ":" + pad(date.getSeconds()) +
    dif + pad(tzo / 60) +
    ":" + pad(tzo % 60);
}
